/** @sfdc-extension-file SNK */
/** Splat route for /category/* resolve the leaf slug, then delegate to the flat route. */
import CategoryPage, { loader as categoryLoader, shouldRevalidate } from './_app.category.$categoryId';
import type { Route } from './+types/_app.category.$';
import type { Route as CategoryRoute } from './+types/_app.category.$categoryId';
import { NormalizedApiError } from '@/lib/api/normalized-api-error';
import { canonicalizeCategoryHierarchyPath, normalizeHierarchyPath } from '@/extensions/snk/lib/hierarchy-url';
import { redirectIfNonCanonicalHierarchyPath } from '@/extensions/snk/lib/hierarchy-url-redirect.server';
import { resolveCategoryIdFromHierarchyPath } from '@/extensions/snk/lib/hierarchy-url.server';
import { routes } from '@/route-paths';

export async function loader(args: Route.LoaderArgs) {
    try {
        const hierarchyPath = args.params['*'] ?? '';
        const normalized = normalizeHierarchyPath(hierarchyPath) ?? '';
        const canonical = canonicalizeCategoryHierarchyPath(hierarchyPath) ?? '';

        redirectIfNonCanonicalHierarchyPath({
            context: args.context,
            request: args.request,
            requestPath: normalized,
            canonicalPath: canonical,
            routePattern: routes.categoryHierarchy,
        });

        const categoryId = canonical ? await resolveCategoryIdFromHierarchyPath(args.context, canonical) : '';

        if (!categoryId) {
            throw new Response('Category not found', { status: 404 });
        }

        return categoryLoader({
            ...args,
            params: { categoryId },
        } as CategoryRoute.LoaderArgs);
    } catch (error) {
        throw toLoaderResponse(error);
    }
}

/** Same mapping as the flat category loader: keep Response, map API status, else 500. */
function toLoaderResponse(error: unknown): Response {
    if (error instanceof Response) return error;
    if (error instanceof NormalizedApiError && error.status) {
        return new Response(error.message, { status: error.status });
    }
    return new Response('Internal Server Error', { status: 500 });
}

export { shouldRevalidate };
export default CategoryPage;
